import {Pinia} from "pinia";
import {useMyStore} from "@/store/other/mystore";

export const myStore = {
  useMyStore: (pinia?: Pinia) => useMyStore(pinia),
}
